// extracted by mini-css-extract-plugin
module.exports = {"Content":"List_Content__2HtNr","Link":"List_Link__3n-pm"};